import React, { useRef, useMemo } from 'react'
import { Formik, Form, Field, FieldArray } from 'formik'
import { CheckAllTopicField } from './CheckAllTopicField'
import { CheckAllModulesField } from './CheckAllModulesField'
import { BorderContainer } from '../../BorderContainer'
import { CustomField } from './CustomField'
import { Substance } from './Substance'
import { Margin } from '../../Margin'
import { FormHeader, Button } from '../style'

const checkboxStyle = {
    width: '1em',
    height: '1em',
    verticalAlign: 'text-top'
}

export const Constructor = ({ pimData, takePrintVersion }) => {
    const ref = useRef(null)

    const currentScore = (checkedIds, data) => {
        let count = 0

        checkedIds.length > 0 && checkedIds.forEach(id => {
            count += +data.find(i => i.id == id).weight
        })

        return count
    }

    const handleSubmit = (values, { setSubmitting }) => {
        const dataTopics = values.checkedTopics.map( id => {
            const topic = pimData.topics.find( t => t.id == id)
            if (topic) return topic
        })
        const dataModules = values.checkedModules.map( id => {
            const module = pimData.modules.find( m => m.id == id)
            if (module) return module
        })

        takePrintVersion(dataTopics, dataModules, pimData.cases, ref)
        setSubmitting(false)
    }

    return (
        <Formik
            initialValues={{
                topics: pimData.topics,
                checkedTopics: [],
                checkAllTopics: false,

                modules: pimData.modules,
                checkedModules: [],
                checkAllModules: false
            }}

            onSubmit={handleSubmit}
        >
            {({ values }) => (
                <Form>
                    <Margin bottom='22px'>
                        <div className="text-center">
                            <label>Блок 1. Темы</label>
                        </div>
                        <FormHeader>
                            <div>(cумма баллов должна быть <label>не менее {pimData.block1Criterion}</label>)</div>
                            <div>cумма баллов: {useMemo(() => currentScore(values.checkedTopics, pimData.topics), [values.checkedTopics])} </div>
                        </FormHeader>
                        <BorderContainer>
                            <CustomField
                                field={<CheckAllTopicField name='checkAllTopics' type="checkbox" style={checkboxStyle} />}
                                title='Все темы'
                                weight={<strong>Балл</strong>}
                            />
                            <FieldArray
                                name="topics"
                                render={(a) => (
                                    <div>
                                        {values.topics.map((i, idx) => (
                                            <CustomField
                                                key={i.id}
                                                field={<Field name='checkedTopics' type='checkbox' value={i.id.toString()} style={checkboxStyle} />}
                                                title='Тема'
                                                count={idx + 1}
                                                description={i.name}
                                                weight={i.weight}
                                            />
                                        ))}
                                    </div>
                                )}
                            />
                        </BorderContainer>
                    </Margin>

                    <Margin bottom='10px'>
                        <div className="text-center">
                            <label>Блок 2. Модули</label>
                        </div>
                        <FormHeader>
                            <div>(cумма баллов должна быть <label>не менее {pimData.block2Criterion}</label>)</div>
                            <div>cумма баллов: {useMemo(() => currentScore(values.checkedModules, pimData.modules), [values.checkedModules])} </div>
                        </FormHeader>
                        <BorderContainer>
                            <CustomField
                                field={<CheckAllModulesField name='checkAllModules' type="checkbox" style={checkboxStyle} />}
                                title='Все модули'
                                weight={<strong>Балл</strong>}
                            />
                            <FieldArray
                                name="modules"
                                render={() => (
                                    <>
                                        {values.modules.map((i, idx) => (
                                            <CustomField
                                                key={i.id}
                                                field={<Field name='checkedModules' type='checkbox' value={i.id.toString()} style={checkboxStyle} />}
                                                title='Модуль'
                                                count={idx + 1}
                                                description={i.name}
                                                weight={i.weight}
                                            />
                                        ))}
                                    </>
                                )}
                            />
                        </BorderContainer>
                    </Margin>

                    <Margin bottom='22px'>
                        <Substance pimData={pimData} topicsId={values.checkedTopics} modulesId={values.checkedModules} />
                    </Margin>

                    <Button className="btn btn-primary" type="submit" >
                        <span className="glyphicon glyphicon-print" /> Версия для печати
                    </Button>
                    <a style={{ display: 'none' }} ref={ref}></a>
                </Form>
            )}
        </Formik>
    )
}
